import IconBase from "./IconBase";

// People, for member counts and access lists.
const UsersIcon = (props) => (
    <IconBase {...props}>
        <circle cx="9.5" cy="8" r="3.75" />
        <path d="M3 20.25a6.5 6.5 0 0 1 13 0" />
        <path d="M16.25 4.6a3.75 3.75 0 0 1 0 6.8" />
        <path d="M18.5 14.6a6.5 6.5 0 0 1 2.5 5.65" />
    </IconBase>
);

export default UsersIcon;
